import { Component, ViewEncapsulation, input } from '@angular/core';

@Component({
    selector: 'ap-square-skeleton',
    templateUrl: './square-skeleton.component.html',
    styleUrls: ['./square-skeleton.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApSquareSkeletonComponent {
    /**
     * Height of skeleton square.
     * Defaults to `250px`.
     */
    public readonly squareHeight = input('250px');
}
